module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/scentbird-box_362f43.png";